import { render, staticRenderFns } from "./ArticuloStepper.vue?vue&type=template&id=0d791412"
import script from "./ArticuloStepper.vue?vue&type=script&lang=js"
export * from "./ArticuloStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports